module.exports = __webpack_public_path__ + "static/media/waveform.c9312b4a.svg";